// Çok dilli metinler. Dil seçimi URL parametresi ile yapılır: ?lang=tr|en|es|de|it|pl|hu
// WordPress iframe örneği: <iframe src="https://.../index.html?lang=de"></iframe>

export const SUPPORTED_LANGS = ["tr", "en", "es", "de", "it", "pl", "hu"];

export const LANG_NAMES = {
    tr: "Türkçe",
    en: "English",
    es: "Español",
    de: "Deutsch",
    it: "Italiano",
    pl: "Polski",
    hu: "Magyar",
};

export const LOCALES = {
    tr: "tr-TR",
    en: "en-US",
    es: "es-ES",
    de: "de-DE",
    it: "it-IT",
    pl: "pl-PL",
    hu: "hu-HU",
};

export function getInitialLang() {
    try {
        const param = new URLSearchParams(window.location.search).get("lang");
        if (param && SUPPORTED_LANGS.includes(param.toLowerCase())) {
            return param.toLowerCase();
        }
        const browser = (navigator.language || "").slice(0, 2).toLowerCase();
        if (SUPPORTED_LANGS.includes(browser)) return browser;
    } catch (e) {
        // SSR / kısıtlı ortam
    }
    return "tr";
}

const translations = {
    tr: {
        tabCoil: "Rulo Hesaplayıcı",
        tabZigzag: "Zigzag Verimlilik Hesaplayıcı",

        zzSubtitle: "Pul kesim dizilim optimizasyonu",
        discProps: "Pul Özellikleri",
        coilProps: "Rulo Özellikleri",
        quantity: "Adet",
        densityWithUnit: "Yoğunluk (kg/m³)",
        single: "Tek",
        double: "Çift",
        triple: "Üçlü",
        quad: "Dörtlü",
        doubleZigzag: "Çift (Zigzag)",
        coilWeightLabel: "Rulo Ağırlığı (Kg)",
        weightKg: "Ağırlık (kg)",
        pressTable: "Pres Tablası (mm)",
        totalLength: "Toplam Boy (mm)",
        efficiency: "Verim",
        pieceKg: "Parça (kg)",
        scrapKg: "Fire (kg)",
        advantage: "Avantaj",
        layoutVisual: "Dizilim Görseli",

        coilTitle: "Rulo Hesaplama",
        material: "Malzeme",
        select: "Seç",
        density: "Yoğunluk",
        thickness: "Kalınlık",
        width: "Genişlik",
        innerDiameter: "İç Çap",
        outerDiameter: "Dış Çap",
        weight: "Ağırlık",
        length: "Uzunluk",
        clear: "Temizle",
        calculate: "Hesapla",

        matSteel: "Karbon Çeliği",
        matStainless: "Paslanmaz Çelik",
        matAluminum: "Alüminyum",
        matCopper: "Bakır",
        matBrass: "Pirinç",
        matCastIron: "Dökme Demir",
        matPP: "PP / Polipropilen",
        matPE: "PE / Polietilen",
        matPVC: "PVC",
        matCustom: "Özel / Manuel",

        errDensity: "Yoğunluk geçerli değil.",
        errThickness: "Kalınlık geçerli değil.",
        errWidth: "Genişlik geçerli değil.",
        errInnerDia: "İç çap geçerli değil.",
        errOuterDia: "Dış çap geçerli değil.",
        errOuterGtInner: "Dış çap, iç çaptan büyük olmalı.",
        errWeight: "Ağırlık geçerli değil.",
        errLength: "Uzunluk geçerli değil.",
        errKgPerMm: "kg/mm geçerli değil.",
        errNeedOne: "Dış çap, ağırlık, uzunluk veya kg/mm alanlarından en az birini gir.",
        errAllFilled: "Tüm sonuç alanları dolu. Birini boş bırak veya temizle.",
        errCalc: "Hesaplama yapılamadı.",

        disclaimer: "Hesaplanan sonuçlar sadece rehber olarak kullanılmalıdır ve garanti edilemez; yanlış değerler girilirse geçersiz sonuç çıkar.",
    },

    en: {
        tabCoil: "Coil Calculator",
        tabZigzag: "Zigzag Efficiency Calculator",

        zzSubtitle: "Blanking layout optimization",
        discProps: "Disc Properties",
        coilProps: "Coil Properties",
        quantity: "Quantity",
        densityWithUnit: "Density (kg/m³)",
        single: "Single",
        double: "Double",
        triple: "Triple",
        quad: "Quadruple",
        doubleZigzag: "Double (Zigzag)",
        coilWeightLabel: "Coil Weight (kg)",
        weightKg: "Weight (kg)",
        pressTable: "Press Table (mm)",
        totalLength: "Total Length (mm)",
        efficiency: "Efficiency",
        pieceKg: "Part (kg)",
        scrapKg: "Scrap (kg)",
        advantage: "Advantage",
        layoutVisual: "Layout Preview",

        coilTitle: "Coil Calculation",
        material: "Material",
        select: "Select",
        density: "Density",
        thickness: "Thickness",
        width: "Width",
        innerDiameter: "Inner Diameter",
        outerDiameter: "Outer Diameter",
        weight: "Weight",
        length: "Length",
        clear: "Clear",
        calculate: "Calculate",

        matSteel: "Steel",
        matStainless: "Stainless Steel",
        matAluminum: "Aluminum",
        matCopper: "Copper",
        matBrass: "Brass",
        matCastIron: "Cast Iron",
        matPP: "PP / Polypropylene",
        matPE: "PE / Polyethylene",
        matPVC: "PVC",
        matCustom: "Custom / Manual",

        errDensity: "Density is not valid.",
        errThickness: "Thickness is not valid.",
        errWidth: "Width is not valid.",
        errInnerDia: "Inner diameter is not valid.",
        errOuterDia: "Outer diameter is not valid.",
        errOuterGtInner: "Outer diameter must be greater than inner diameter.",
        errWeight: "Weight is not valid.",
        errLength: "Length is not valid.",
        errKgPerMm: "kg/mm is not valid.",
        errNeedOne: "Enter at least one of: outer diameter, weight, length or kg/mm.",
        errAllFilled: "All result fields are filled. Leave one empty or clear.",
        errCalc: "Calculation failed.",

        disclaimer: "Calculated results should be used as a guide only and are not guaranteed; entering incorrect values will produce invalid results.",
    },

    es: {
        tabCoil: "Calculadora de Bobinas",
        tabZigzag: "Calculadora de Eficiencia Zigzag",

        zzSubtitle: "Optimización de la disposición de corte de discos",
        discProps: "Propiedades del Disco",
        coilProps: "Propiedades de la Bobina",
        quantity: "Cantidad",
        densityWithUnit: "Densidad (kg/m³)",
        single: "Simple",
        double: "Doble",
        triple: "Triple",
        quad: "Cuádruple",
        doubleZigzag: "Doble (Zigzag)",
        coilWeightLabel: "Peso de la Bobina (kg)",
        weightKg: "Peso (kg)",
        pressTable: "Mesa de Prensa (mm)",
        totalLength: "Longitud Total (mm)",
        efficiency: "Eficiencia",
        pieceKg: "Pieza (kg)",
        scrapKg: "Desperdicio (kg)",
        advantage: "Ventaja",
        layoutVisual: "Vista de Disposición",

        coilTitle: "Cálculo de Bobina",
        material: "Material",
        select: "Seleccionar",
        density: "Densidad",
        thickness: "Espesor",
        width: "Ancho",
        innerDiameter: "Diámetro Interior",
        outerDiameter: "Diámetro Exterior",
        weight: "Peso",
        length: "Longitud",
        clear: "Limpiar",
        calculate: "Calcular",

        matSteel: "Acero",
        matStainless: "Acero Inoxidable",
        matAluminum: "Aluminio",
        matCopper: "Cobre",
        matBrass: "Latón",
        matCastIron: "Hierro Fundido",
        matPP: "PP / Polipropileno",
        matPE: "PE / Polietileno",
        matPVC: "PVC",
        matCustom: "Personalizado / Manual",

        errDensity: "La densidad no es válida.",
        errThickness: "El espesor no es válido.",
        errWidth: "El ancho no es válido.",
        errInnerDia: "El diámetro interior no es válido.",
        errOuterDia: "El diámetro exterior no es válido.",
        errOuterGtInner: "El diámetro exterior debe ser mayor que el interior.",
        errWeight: "El peso no es válido.",
        errLength: "La longitud no es válida.",
        errKgPerMm: "kg/mm no es válido.",
        errNeedOne: "Introduce al menos uno: diámetro exterior, peso, longitud o kg/mm.",
        errAllFilled: "Todos los campos de resultado están llenos. Deja uno vacío o limpia.",
        errCalc: "No se pudo calcular.",

        disclaimer: "Los resultados calculados deben usarse solo como guía y no están garantizados; si se introducen valores incorrectos, el resultado será inválido.",
    },

    de: {
        tabCoil: "Coil-Rechner",
        tabZigzag: "Zickzack-Effizienzrechner",

        zzSubtitle: "Optimierung der Ronden-Schnittanordnung",
        discProps: "Ronden-Eigenschaften",
        coilProps: "Coil-Eigenschaften",
        quantity: "Stückzahl",
        densityWithUnit: "Dichte (kg/m³)",
        single: "Einfach",
        double: "Doppelt",
        triple: "Dreifach",
        quad: "Vierfach",
        doubleZigzag: "Doppelt (Zickzack)",
        coilWeightLabel: "Coilgewicht (kg)",
        weightKg: "Gewicht (kg)",
        pressTable: "Pressentisch (mm)",
        totalLength: "Gesamtlänge (mm)",
        efficiency: "Effizienz",
        pieceKg: "Teil (kg)",
        scrapKg: "Verschnitt (kg)",
        advantage: "Vorteil",
        layoutVisual: "Anordnungsansicht",

        coilTitle: "Coil-Berechnung",
        material: "Werkstoff",
        select: "Wählen",
        density: "Dichte",
        thickness: "Dicke",
        width: "Breite",
        innerDiameter: "Innendurchmesser",
        outerDiameter: "Außendurchmesser",
        weight: "Gewicht",
        length: "Länge",
        clear: "Zurücksetzen",
        calculate: "Berechnen",

        matSteel: "Stahl",
        matStainless: "Edelstahl",
        matAluminum: "Aluminium",
        matCopper: "Kupfer",
        matBrass: "Messing",
        matCastIron: "Gusseisen",
        matPP: "PP / Polypropylen",
        matPE: "PE / Polyethylen",
        matPVC: "PVC",
        matCustom: "Benutzerdefiniert / Manuell",

        errDensity: "Die Dichte ist ungültig.",
        errThickness: "Die Dicke ist ungültig.",
        errWidth: "Die Breite ist ungültig.",
        errInnerDia: "Der Innendurchmesser ist ungültig.",
        errOuterDia: "Der Außendurchmesser ist ungültig.",
        errOuterGtInner: "Der Außendurchmesser muss größer als der Innendurchmesser sein.",
        errWeight: "Das Gewicht ist ungültig.",
        errLength: "Die Länge ist ungültig.",
        errKgPerMm: "kg/mm ist ungültig.",
        errNeedOne: "Gib mindestens eines an: Außendurchmesser, Gewicht, Länge oder kg/mm.",
        errAllFilled: "Alle Ergebnisfelder sind gefüllt. Lass eines leer oder setze zurück.",
        errCalc: "Berechnung fehlgeschlagen.",

        disclaimer: "Die berechneten Ergebnisse dienen nur als Richtwert und sind ohne Gewähr; bei falschen Eingabewerten sind die Ergebnisse ungültig.",
    },

    it: {
        tabCoil: "Calcolatore Coil",
        tabZigzag: "Calcolatore di Efficienza Zigzag",

        zzSubtitle: "Ottimizzazione della disposizione di tranciatura",
        discProps: "Proprietà del Disco",
        coilProps: "Proprietà del Coil",
        quantity: "Quantità",
        densityWithUnit: "Densità (kg/m³)",
        single: "Singola",
        double: "Doppia",
        triple: "Tripla",
        quad: "Quadrupla",
        doubleZigzag: "Doppia (Zigzag)",
        coilWeightLabel: "Peso del Coil (kg)",
        weightKg: "Peso (kg)",
        pressTable: "Tavola Pressa (mm)",
        totalLength: "Lunghezza Totale (mm)",
        efficiency: "Efficienza",
        pieceKg: "Pezzo (kg)",
        scrapKg: "Sfrido (kg)",
        advantage: "Vantaggio",
        layoutVisual: "Anteprima Disposizione",

        coilTitle: "Calcolo Coil",
        material: "Materiale",
        select: "Seleziona",
        density: "Densità",
        thickness: "Spessore",
        width: "Larghezza",
        innerDiameter: "Diametro Interno",
        outerDiameter: "Diametro Esterno",
        weight: "Peso",
        length: "Lunghezza",
        clear: "Pulisci",
        calculate: "Calcola",

        matSteel: "Acciaio",
        matStainless: "Acciaio Inox",
        matAluminum: "Alluminio",
        matCopper: "Rame",
        matBrass: "Ottone",
        matCastIron: "Ghisa",
        matPP: "PP / Polipropilene",
        matPE: "PE / Polietilene",
        matPVC: "PVC",
        matCustom: "Personalizzato / Manuale",

        errDensity: "La densità non è valida.",
        errThickness: "Lo spessore non è valido.",
        errWidth: "La larghezza non è valida.",
        errInnerDia: "Il diametro interno non è valido.",
        errOuterDia: "Il diametro esterno non è valido.",
        errOuterGtInner: "Il diametro esterno deve essere maggiore di quello interno.",
        errWeight: "Il peso non è valido.",
        errLength: "La lunghezza non è valida.",
        errKgPerMm: "kg/mm non è valido.",
        errNeedOne: "Inserisci almeno uno tra: diametro esterno, peso, lunghezza o kg/mm.",
        errAllFilled: "Tutti i campi risultato sono pieni. Lasciane uno vuoto o pulisci.",
        errCalc: "Calcolo non riuscito.",

        disclaimer: "I risultati calcolati devono essere usati solo come guida e non sono garantiti; inserendo valori errati si otterranno risultati non validi.",
    },

    pl: {
        tabCoil: "Kalkulator Kręgów",
        tabZigzag: "Kalkulator Wydajności Zygzak",

        zzSubtitle: "Optymalizacja układu wykrawania krążków",
        discProps: "Właściwości Krążka",
        coilProps: "Właściwości Kręgu",
        quantity: "Ilość",
        densityWithUnit: "Gęstość (kg/m³)",
        single: "Pojedynczy",
        double: "Podwójny",
        triple: "Potrójny",
        quad: "Poczwórny",
        doubleZigzag: "Podwójny (Zygzak)",
        coilWeightLabel: "Masa Kręgu (kg)",
        weightKg: "Masa (kg)",
        pressTable: "Stół Prasy (mm)",
        totalLength: "Długość Całkowita (mm)",
        efficiency: "Wydajność",
        pieceKg: "Część (kg)",
        scrapKg: "Odpad (kg)",
        advantage: "Korzyść",
        layoutVisual: "Podgląd Układu",

        coilTitle: "Obliczenia Kręgu",
        material: "Materiał",
        select: "Wybierz",
        density: "Gęstość",
        thickness: "Grubość",
        width: "Szerokość",
        innerDiameter: "Średnica Wewnętrzna",
        outerDiameter: "Średnica Zewnętrzna",
        weight: "Masa",
        length: "Długość",
        clear: "Wyczyść",
        calculate: "Oblicz",

        matSteel: "Stal",
        matStainless: "Stal Nierdzewna",
        matAluminum: "Aluminium",
        matCopper: "Miedź",
        matBrass: "Mosiądz",
        matCastIron: "Żeliwo",
        matPP: "PP / Polipropylen",
        matPE: "PE / Polietylen",
        matPVC: "PVC",
        matCustom: "Niestandardowy / Ręczny",

        errDensity: "Gęstość jest nieprawidłowa.",
        errThickness: "Grubość jest nieprawidłowa.",
        errWidth: "Szerokość jest nieprawidłowa.",
        errInnerDia: "Średnica wewnętrzna jest nieprawidłowa.",
        errOuterDia: "Średnica zewnętrzna jest nieprawidłowa.",
        errOuterGtInner: "Średnica zewnętrzna musi być większa od wewnętrznej.",
        errWeight: "Masa jest nieprawidłowa.",
        errLength: "Długość jest nieprawidłowa.",
        errKgPerMm: "kg/mm jest nieprawidłowe.",
        errNeedOne: "Podaj co najmniej jedno: średnicę zewnętrzną, masę, długość lub kg/mm.",
        errAllFilled: "Wszystkie pola wyników są wypełnione. Zostaw jedno puste lub wyczyść.",
        errCalc: "Obliczenie nie powiodło się.",

        disclaimer: "Obliczone wyniki należy traktować wyłącznie jako wskazówkę i nie są gwarantowane; wprowadzenie błędnych wartości da nieprawidłowy wynik.",
    },

    hu: {
        tabCoil: "Tekercs Kalkulátor",
        tabZigzag: "Cikcakk Hatékonyság Kalkulátor",

        zzSubtitle: "Tárcsakivágási elrendezés optimalizálása",
        discProps: "Tárcsa Tulajdonságai",
        coilProps: "Tekercs Tulajdonságai",
        quantity: "Darabszám",
        densityWithUnit: "Sűrűség (kg/m³)",
        single: "Egysoros",
        double: "Kétsoros",
        triple: "Háromsoros",
        quad: "Négysoros",
        doubleZigzag: "Kétsoros (Cikcakk)",
        coilWeightLabel: "Tekercs Tömege (kg)",
        weightKg: "Tömeg (kg)",
        pressTable: "Présasztal (mm)",
        totalLength: "Teljes Hossz (mm)",
        efficiency: "Hatékonyság",
        pieceKg: "Darab (kg)",
        scrapKg: "Hulladék (kg)",
        advantage: "Előny",
        layoutVisual: "Elrendezés Nézet",

        coilTitle: "Tekercs Számítás",
        material: "Anyag",
        select: "Válassz",
        density: "Sűrűség",
        thickness: "Vastagság",
        width: "Szélesség",
        innerDiameter: "Belső Átmérő",
        outerDiameter: "Külső Átmérő",
        weight: "Tömeg",
        length: "Hossz",
        clear: "Törlés",
        calculate: "Számítás",

        matSteel: "Acél",
        matStainless: "Rozsdamentes Acél",
        matAluminum: "Alumínium",
        matCopper: "Réz",
        matBrass: "Sárgaréz",
        matCastIron: "Öntöttvas",
        matPP: "PP / Polipropilén",
        matPE: "PE / Polietilén",
        matPVC: "PVC",
        matCustom: "Egyedi / Kézi",

        errDensity: "A sűrűség érvénytelen.",
        errThickness: "A vastagság érvénytelen.",
        errWidth: "A szélesség érvénytelen.",
        errInnerDia: "A belső átmérő érvénytelen.",
        errOuterDia: "A külső átmérő érvénytelen.",
        errOuterGtInner: "A külső átmérőnek nagyobbnak kell lennie a belsőnél.",
        errWeight: "A tömeg érvénytelen.",
        errLength: "A hossz érvénytelen.",
        errKgPerMm: "A kg/mm érvénytelen.",
        errNeedOne: "Add meg legalább az egyiket: külső átmérő, tömeg, hossz vagy kg/mm.",
        errAllFilled: "Minden eredménymező kitöltve. Hagyj egyet üresen vagy törölj.",
        errCalc: "A számítás nem sikerült.",

        disclaimer: "A számított eredmények csak iránymutatásként használhatók, garancia nélkül; hibás értékek megadása érvénytelen eredményt ad.",
    },
};

export function getTranslations(lang) {
    return translations[lang] || translations.tr;
}
